import type { FC, ReactNode } from "react";
import React from "react";
import { DebugSectionContainer } from "./debug.styles";

interface DebugSectionProps {
  title: string;
  children?: ReactNode;
  defaultOpen?: boolean;
}

const DebugSection: FC<DebugSectionProps> = ({
  title,
  children,
  defaultOpen = false
}) => {
  return (
    <DebugSectionContainer open={defaultOpen}>
      <summary>{title}</summary>
      <div className="content">{children}</div>
    </DebugSectionContainer>
  );
};

export default DebugSection;
